// Translation strings for the site (EN + AR)
export const translations = {
  en: {
    nav: {
      home: "Home",
      treatments: "Treatments",
      hospitals: "Hospitals",
      doctors: "Doctors",
      services: "Services",
      about: "About",
      blog: "Blog",
      contact: "Contact",
      consult: "Free Consultation",
    },
    hero: {
      eyebrow: "Medical Tourism · New Delhi, India",
      title: "World-class treatment. Handled with khidmat.",
      subtitle: "Al Khidmaat Medical connects international patients with Delhi NCR's top JCI-accredited hospitals — from cardiac surgery to IVF, at a fraction of Western costs.",
      cta_primary: "Get Free Consultation",
      cta_secondary: "Explore Treatments",
      stat_patients: "Patients Served",
      stat_hospitals: "Partner Hospitals",
      stat_countries: "Countries",
      stat_saved: "Avg. Cost Saved",
    },
    trust: {
      title: "Affiliated with the finest hospitals in Delhi NCR",
      subtitle: "JCI & NABH accredited institutions delivering global standards of care.",
    },
    treatments: {
      title: "Treatments we specialize in",
      subtitle: "From critical procedures to elective care — a curated network of experts by your side.",
      from: "from",
      duration: "Stay",
      view_all: "View all treatments",
    },
    why: {
      title: "Why choose Al Khidmaat",
      subtitle: "A companion, not just an agency. We walk with you through every step.",
      p1_title: "End-to-end concierge",
      p1_body: "Visa, airport pickup, hotel, translator, second opinions, appointments — all handled.",
      p2_title: "Handpicked hospitals",
      p2_body: "Only JCI/NABH accredited hospitals with proven outcomes and international patient wings.",
      p3_title: "Transparent pricing",
      p3_body: "Written estimates with no hidden costs. Save 60–80% versus USA/UK/GCC.",
      p4_title: "24/7 human support",
      p4_body: "One WhatsApp away — before, during and long after your treatment.",
    },
    services: {
      title: "Concierge services included",
      items: [
        ["Medical Visa Assistance", "Documentation, invitation letters, embassy support."],
        ["Airport Pickup & Transfers", "Chauffeured pickup on arrival and hospital transfers."],
        ["Accommodation", "Verified hotels & serviced apartments near your hospital."],
        ["Language Translators", "Arabic, Russian, French, Swahili and more."],
        ["Second Opinions", "Free virtual consultations before you travel."],
        ["Post-treatment Follow-up", "Teleconsultations for months after you return home."],
      ],
    },
    hospitals: {
      title: "Our partner hospitals",
      subtitle: "Every hospital vetted for outcomes, ethics and international patient experience.",
      beds: "beds",
      established: "Est.",
      view: "View hospital",
    },
    doctors: {
      title: "Meet leading specialists",
      subtitle: "Some of India's most respected doctors — accessible through Al Khidmaat.",
      years_exp: "years experience",
      view_all: "See all doctors",
    },
    testimonials: {
      title: "Stories of healing",
      subtitle: "Patients from across the world trust us with their care.",
    },
    inquiry: {
      title: "Get a free medical consultation",
      subtitle: "Share a few details. Our patient team will reach out within 24 hours with expert options and a written cost estimate.",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      country: "Country",
      treatment: "Treatment or medical concern",
      message: "Tell us more (optional)",
      submit: "Send inquiry",
      submitting: "Sending...",
      success: "Thank you! Our team will contact you within 24 hours.",
      error: "Something went wrong. Please try WhatsApp instead.",
      whatsapp: "Or chat on WhatsApp",
    },
    blog: { title: "Insights & guides", subtitle: "Latest on medical travel, treatments, and patient journeys.", read: "Read article" },
    footer: {
      tagline: "Trusted medical tourism partner in New Delhi, India.",
      quick: "Quick links",
      contact: "Contact",
      follow: "Follow us",
      rights: "All rights reserved.",
      address: "New Delhi, India",
    },
    contact: {
      title: "Get in touch",
      subtitle: "We're here 24/7 for you and your family.",
      email: "Email",
      phone: "Phone / WhatsApp",
      address: "Address",
      form_title: "Send us a message",
    },
    about: {
      title: "About Al Khidmaat Medical",
      lead: "Al Khidmaat Medical (New Delhi, India) is a boutique medical tourism company built on one belief: quality healthcare is a right, not a privilege of geography. We partner with Delhi NCR's finest hospitals to bring world-class treatment within reach of patients from the Middle East, Africa, CIS, and beyond.",
      mission_title: "Our mission",
      mission_body: "To simplify the medical travel journey with honesty, dignity, and genuine care — from the first phone call to the day you return home healthy.",
      values_title: "What we stand for",
      values: [
        ["Khidmat first", "Service above all. Your comfort and dignity guide every decision."],
        ["Transparency", "No hidden costs. No commissions from doctors. Written estimates always."],
        ["Access", "Best doctors, best hospitals — for every budget."],
      ],
    },
    admin: {
      login_title: "Admin Login",
      email: "Email",
      password: "Password",
      login: "Sign in",
      dashboard: "Dashboard",
      logout: "Logout",
      inquiries: "Inquiries",
      hospitals: "Hospitals",
      doctors: "Doctors",
      treatments: "Treatments",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      treatments: "العلاجات",
      hospitals: "المستشفيات",
      doctors: "الأطباء",
      services: "الخدمات",
      about: "من نحن",
      blog: "المدونة",
      contact: "اتصل بنا",
      consult: "استشارة مجانية",
    },
    hero: {
      eyebrow: "السياحة العلاجية · نيودلهي، الهند",
      title: "علاج عالمي بأيدٍ أمينة… بخدمة تليق بك.",
      subtitle: "تربط الخدمات الطبية المرضى الدوليين بأفضل مستشفيات دلهي إن سي آر المعتمدة دولياً — من جراحة القلب إلى أطفال الأنابيب، بجزء بسيط من التكاليف الغربية.",
      cta_primary: "احصل على استشارة مجانية",
      cta_secondary: "استكشف العلاجات",
      stat_patients: "مريض تمت خدمته",
      stat_hospitals: "مستشفى شريك",
      stat_countries: "دولة",
      stat_saved: "متوسط التوفير",
    },
    trust: {
      title: "شراكة مع أفضل مستشفيات دلهي إن سي آر",
      subtitle: "مؤسسات معتمدة من JCI و NABH بمعايير رعاية عالمية.",
    },
    treatments: {
      title: "تخصصاتنا العلاجية",
      subtitle: "من العمليات الحرجة إلى الرعاية الاختيارية — شبكة مختارة من الخبراء.",
      from: "من",
      duration: "الإقامة",
      view_all: "عرض كل العلاجات",
    },
    why: {
      title: "لماذا الخدمات الطبية",
      subtitle: "رفيق وليس مجرد وكالة. نمشي معك في كل خطوة.",
      p1_title: "خدمة كونسيرج شاملة",
      p1_body: "التأشيرة، الاستقبال بالمطار، الفندق، المترجم، الرأي الثاني، المواعيد — كلها مسؤوليتنا.",
      p2_title: "مستشفيات مختارة",
      p2_body: "فقط مستشفيات معتمدة JCI/NABH بنتائج مثبتة وأجنحة دولية للمرضى.",
      p3_title: "أسعار شفافة",
      p3_body: "تقديرات مكتوبة بدون رسوم خفية. وفّر 60–80٪ مقارنة بأمريكا وبريطانيا والخليج.",
      p4_title: "دعم بشري 24/7",
      p4_body: "رسالة واتساب واحدة — قبل، أثناء، وبعد العلاج بشهور.",
    },
    services: {
      title: "خدمات الكونسيرج المشمولة",
      items: [
        ["مساعدة التأشيرة الطبية", "الوثائق وخطابات الدعوة والتواصل مع السفارات."],
        ["الاستقبال بالمطار والتنقلات", "استقبال بالسيارة عند الوصول والتنقل إلى المستشفى."],
        ["الإقامة", "فنادق وشقق فندقية موثوقة قرب المستشفى."],
        ["مترجمون لغويون", "عربي، روسي، فرنسي، سواحيلي والمزيد."],
        ["الرأي الطبي الثاني", "استشارات افتراضية مجانية قبل السفر."],
        ["المتابعة بعد العلاج", "متابعة عن بعد لأشهر بعد عودتك للوطن."],
      ],
    },
    hospitals: {
      title: "مستشفياتنا الشريكة",
      subtitle: "كل مستشفى مختار بعناية لنتائجه وأخلاقياته وتجربته للمرضى الدوليين.",
      beds: "سرير",
      established: "تأسس",
      view: "عرض المستشفى",
    },
    doctors: {
      title: "تعرّف على أبرز الأخصائيين",
      subtitle: "بعض من أبرز أطباء الهند — عبر الخدمات الطبية.",
      years_exp: "سنة خبرة",
      view_all: "كل الأطباء",
    },
    testimonials: {
      title: "قصص شفاء",
      subtitle: "مرضى من كل العالم يثقون بنا في رحلتهم العلاجية.",
    },
    inquiry: {
      title: "احصل على استشارة طبية مجانية",
      subtitle: "شارك معنا بضعة تفاصيل وسيتواصل معك فريقنا خلال 24 ساعة بخيارات الخبراء وتقدير مكتوب للتكلفة.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف / واتساب",
      country: "الدولة",
      treatment: "العلاج أو الحالة الطبية",
      message: "أخبرنا المزيد (اختياري)",
      submit: "إرسال الطلب",
      submitting: "جارٍ الإرسال...",
      success: "شكراً لك! سيتواصل فريقنا خلال 24 ساعة.",
      error: "حدث خطأ ما. يرجى استخدام واتساب.",
      whatsapp: "أو تواصل عبر واتساب",
    },
    blog: { title: "مقالات ودلائل", subtitle: "أحدث ما يتعلق بالسفر العلاجي والعلاجات ورحلات المرضى.", read: "قراءة المقال" },
    footer: {
      tagline: "شريكك الموثوق للسياحة العلاجية في نيودلهي، الهند.",
      quick: "روابط سريعة",
      contact: "تواصل",
      follow: "تابعنا",
      rights: "جميع الحقوق محفوظة.",
      address: "نيودلهي، الهند",
    },
    contact: {
      title: "تواصل معنا",
      subtitle: "نحن معك 24/7 لك ولعائلتك.",
      email: "البريد الإلكتروني",
      phone: "الهاتف / واتساب",
      address: "العنوان",
      form_title: "أرسل لنا رسالة",
    },
    about: {
      title: "عن الخدمات الطبية",
      lead: "الخدمات الطبية (نيودلهي، الهند) شركة سياحة علاجية بوتيك تأسست على قناعة واحدة: الرعاية الصحية الجيدة حق وليست امتيازاً جغرافياً. نتعاون مع أفضل مستشفيات دلهي إن سي آر لنقدم علاجاً عالمياً في متناول مرضى الشرق الأوسط وأفريقيا ودول الكومنولث وما بعدها.",
      mission_title: "مهمتنا",
      mission_body: "تبسيط رحلة السفر العلاجي بأمانة وكرامة ورعاية حقيقية — من أول مكالمة حتى يوم عودتك بصحة جيدة.",
      values_title: "قيمنا",
      values: [
        ["الخدمة أولاً", "الخدمة قبل كل شيء. راحتك وكرامتك تقودان كل قرار."],
        ["الشفافية", "لا رسوم خفية. لا عمولات من الأطباء. تقديرات مكتوبة دائماً."],
        ["الوصول", "أفضل الأطباء والمستشفيات لكل ميزانية."],
      ],
    },
    admin: {
      login_title: "دخول الإدارة",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      login: "تسجيل الدخول",
      dashboard: "لوحة التحكم",
      logout: "خروج",
      inquiries: "الاستفسارات",
      hospitals: "المستشفيات",
      doctors: "الأطباء",
      treatments: "العلاجات",
    },
  },
};

export const CONTACT = {
  email: "mobashshirindia@gmail.com",
  phone: "+91 9871309446",
  phone_raw: "919871309446",
  whatsapp: "https://wa.me/919871309446",
  facebook: "https://www.facebook.com/alkhidmaatmedical",
  city_en: "New Delhi, India",
  city_ar: "نيودلهي، الهند",
  brand_en: "Al Khidmaat Medical",
  brand_ar: "الخدمات الطبية",
};
